module.exports = __webpack_public_path__ + "img/chain06.c9e616df.png";